export const DEFAULT_TEXT_COLOR = '#333333'
export const LEGAL_TEXT_COLOR = '#757575'
export const DEFAULT_LINK_COLOR = '#2267E8'
